import { create } from 'zustand';
import ServiceEmpresas from '@/services/ServiceEmpresas';
import { notify } from '@/stores/useToast';

type Empresa = any;

interface State {
  lista: Empresa[];
  carregando: boolean;
  detalhe: Empresa | null;
  carregandoDetalhe: boolean;
  buscar: () => Promise<void>;
  abrirDetalhe: (cnpj: string) => Promise<void>;
  fecharDetalhe: () => void;
}

// sequência p/ descartar respostas de detalhe que chegam após fechar/superar (stale)
let detalheReq = 0;

export const useEmpresasStore = create<State>((set) => ({
  lista: [],
  carregando: false,
  detalhe: null,
  carregandoDetalhe: false,
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceEmpresas.listar();
      set({ lista: Array.isArray(data) ? data : (data.content ?? []) });
    } catch {
      notify.error('Erro ao buscar empresas.');
    } finally {
      set({ carregando: false });
    }
  },
  async abrirDetalhe(cnpj) {
    const req = ++detalheReq;
    set({ carregandoDetalhe: true, detalhe: null });
    try {
      const { data } = await ServiceEmpresas.detalhe(cnpj);
      if (req !== detalheReq) return; // fechado ou superado por outra abertura
      set({ detalhe: data });
    } catch {
      if (req === detalheReq) notify.error('Erro ao buscar detalhe da empresa.');
    } finally {
      if (req === detalheReq) set({ carregandoDetalhe: false });
    }
  },
  fecharDetalhe() {
    detalheReq += 1; // invalida qualquer request em voo
    set({ detalhe: null, carregandoDetalhe: false });
  },
}));
